import React from "react";

// Hand-drawn monoline brand icon set for the "Values" section.
// Matches the reference: shield+padlock, scalloped verification seal, heart+leaf.
// Uses currentColor so each icon inherits its card's olive/gold tone.
const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
};

// Privacy → shield with a padlock
export const IconPrivacy = ({ className = "h-5 w-5" }) => (
  <svg {...base} className={className} strokeWidth="1.5" aria-hidden="true">
    <path d="M12 2.5 L19.5 5.6 V11 C19.5 16 16 19.8 12 21.5 C8 19.8 4.5 16 4.5 11 V5.6 Z" />
    <rect x="9" y="11.4" width="6" height="4.9" rx="1.1" />
    <path d="M10.4 11.4 V9.8 A1.6 1.6 0 0 1 13.6 9.8 V11.4" />
    <path d="M12 13.3 V14.3" strokeWidth="1.7" />
  </svg>
);

// Careful review → scalloped wax-seal with a verification check
function scallopPath(cx, cy, rOuter, rInner, bumps) {
  let d = "";
  const step = (Math.PI * 2) / bumps;
  for (let i = 0; i < bumps; i++) {
    const a0 = i * step;
    const a1 = a0 + step;
    const vx = cx + rInner * Math.cos(a0), vy = cy + rInner * Math.sin(a0);
    const mx = cx + rOuter * Math.cos(a0 + step / 2), my = cy + rOuter * Math.sin(a0 + step / 2);
    const nvx = cx + rInner * Math.cos(a1), nvy = cy + rInner * Math.sin(a1);
    d += (i === 0 ? `M ${vx.toFixed(2)} ${vy.toFixed(2)} ` : "");
    d += `Q ${mx.toFixed(2)} ${my.toFixed(2)} ${nvx.toFixed(2)} ${nvy.toFixed(2)} `;
  }
  return d + "Z";
}

export const IconReview = ({ className = "h-5 w-5" }) => (
  <svg {...base} className={className} strokeWidth="1.3" aria-hidden="true">
    <path d={scallopPath(12, 12, 9.4, 7.7, 12)} fill="currentColor" fillOpacity="0.1" />
    <circle cx="12" cy="12" r="5.6" />
    <path d="M9.5 12 l1.8 1.9 l3.4 -3.9" strokeWidth="1.6" />
  </svg>
);

// Intention first → heart with a small leaf sprouting
export const IconIntention = ({ className = "h-5 w-5" }) => (
  <svg {...base} className={className} strokeWidth="1.5" aria-hidden="true">
    <path d="M12 20.3 C6.7 15.9 3.7 13.1 3.7 9.4 C3.7 6.8 5.8 5.2 8 6.1 C9.5 6.8 11 8.4 12 9.7 C13 8.4 14.5 6.8 16 6.1 C18.2 5.2 20.3 6.8 20.3 9.4 C20.3 12.4 18.5 14.7 15.4 17.3" />
    <path d="M15 6.4 C15.7 4.9 17.3 4.4 18.6 4.8 C18.4 6.1 17.4 7.2 16 7.4" strokeWidth="1.3" />
    <path d="M15.2 6.8 C15.9 6.4 16.7 6 17.6 5.9" strokeWidth="1.1" />
  </svg>
);

// Decorative gold corner bracket for the value cards (top-left orientation).
// Mirror with -scale-x-100 / -scale-y-100 for the other corners.
export const CornerBracket = ({ className = "" }) => (
  <svg viewBox="0 0 44 44" className={className} fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M4 17 V9 a5 5 0 0 1 5 -5 H17" strokeWidth="1.3" />
    <path d="M10 21 V15 a4 4 0 0 1 4 -4 H20" strokeWidth="1" opacity="0.7" />
    <path d="M4 25 V22 M22 4 H25" strokeWidth="1.3" />
  </svg>
);
